<template>
    <div>
        <!-- Send Invite Success -->
        <div
            v-if="success"
            data-test-view="send-invites-success"
            data-test-id="send-invite-resent-success"
        >
            <div class="text-center">
                <h3>{{ $t(`usersTeams.sendInvite.labelSentInviteText_1`) }}</h3>
                <h4>{{ $t(`usersTeams.sendInvite.labelSentInviteText_2`) }}</h4>
            </div>

            <div class="footer">
                <button class="btn btn-default" type="button" @click="close">
                    {{ $t("usersTeams.modal.btnClose") }}
                </button>
            </div>
        </div>
        <!--/Send Invite Success -->

        <!-- Send Invite -->
        <div v-else data-test-view="send-invite">
            <l-space :size="1" />

            <l-input-text
                v-model="text"
                type="textarea"
                :label="$t(`usersTeams.sendInvite.labelInviteText`)"
                :optional="true"
                data-test-id="invite-text"
            />

            <!-- Single Invite -->
            <p v-if="isSingleInvite" data-test-id="resend-single">
                {{ $t(`usersTeams.sendInvite.labelResendSingle`) }}
                <span data-test-id="resend-single-name">{{ user.firstname }}</span
                >.
            </p>
            <!--/Single Invite -->

            <!-- Multiple Invite -->
            <div v-else data-test-id="resend-all-form">
                <form name="resend-all" class="form-group">
                    <label for="sendTo-allUsers">
                        <input
                            id="sendTo-allUsers"
                            v-model="sendTo"
                            type="radio"
                            value="allUsers"
                            data-test-id="resend-all"
                        />
                        <span>&nbsp; {{ $t(`usersTeams.sendInvite.labelResendAll`) }}</span>
                    </label>
                    <br />
                    <label for="sendTo-selectTeam">
                        <input
                            id="sendTo-selectTeam"
                            v-model="sendTo"
                            type="radio"
                            value="selectTeam"
                            data-test-id="resend-team"
                        />
                        <span>&nbsp; {{ $t(`usersTeams.sendInvite.labelResendTeam`) }}</span>
                    </label>
                    <br />
                </form>

                <l-space :size="1" />

                <l-select
                    v-show="sendTo === 'selectTeam'"
                    v-model="team"
                    :options="[
                        { value: ``, text: $t(`usersTeams.selectTeam`) },
                        ...localTeams.map(team => ({ value: team._id, text: team.name })),
                    ]"
                    data-test-id="resend-team-select"
                />
            </div>
            <!--/Multiple Invite -->

            <l-space :size="1" />

            <div class="footer">
                <button class="btn btn-primary" data-test-id="send-invite-cancel" @click="close">
                    {{ $t("usersTeams.modal.btnCancel") }}
                </button>
                <button
                    data-test-id="send-invite-send"
                    class="btn btn-raised btn-primary"
                    @click="sendInvite"
                >
                    {{ $t("usersTeams.sendInvite.btnSendInvite") }}
                </button>
            </div>
        </div>
        <!--/Send Invite -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LSelect from "@/components/LSelect";
import LSpace from "@/components/LSpace";

export default {
    components: {
        LInputText,
        LSelect,
        LSpace,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        close: {
            type: Function,
            required: true, // from router-view
        },
    },
    data() {
        return {
            text: this.$t(`usersTeams.sendInvite.defaultInviteText`),
            sendTo: "allUsers",
            team: "",

            success: false,

            isSingleInvite: this.id !== "all",
        };
    },
    computed: {
        ...mapGetters({
            getUser: "users/details/details",
            localTeams: "teams/local/listSortedByName",
        }),
        user() {
            if (this.isSingleInvite) {
                return this.getUser(this.id);
            }
            return null;
        },
    },
    methods: {
        sendInvite() {
            const text = this.text;
            const user = this.id !== "all" ? this.id : null;
            const localTeam = this.sendTo === "selectTeam" ? this.team : null;

            this.$store
                .dispatch({
                    type: "users/invite/send",
                    payload: {
                        text,
                        user,
                        localTeam,
                    },
                })
                .then(() => {
                    this.success = true;
                });
        },
    },
};
</script>

<style scoped></style>
